module.exports = __webpack_public_path__ + "media/images/hapier/conceito_hapier_2-9df9afc0eac40e99ee1d05b148955a90.png";